import React, { Component } from 'react';
import { cx } from 'app/utils';
import {
  login,
  setOwnerId,
  setUserName,
  setIsFollowingInkind,
  setInkindPageThumbnailSmall,
  setInkindTitle,
  setInkindId,
  setInkindRouteId,
  setTimezone,
  setCalendarTimezone,
  setRecipientContactInformation,
} from 'app/actions/session';
import { setFatalCalendarError } from 'app/actions/CalendarActions';
import DI, { store } from 'app';
import moment from 'moment-timezone';
import { apolloFetch } from 'app/utils';
import { setAntiForgeryToken } from 'app/actions/auth/AntiForgeryToken';
import { legacyAppClassName } from 'app/constants';
import '@gik/i18n';
import './fontIconMap';
import { GoogleMapsAPIWrapper, UIWrapperWithSingleton } from '@gik/ui';
import 'spinkit/spinkit.css';

window.moment = moment;

export default class App extends Component {
  state = {
    ready: false,
  };

  componentWillMount () {
    this.setState({ ready: true });

    // JWT authentication
    if (window.__root.graphQLToken) {
      apolloFetch.use(({ options }, next) => {
        if (!options.headers) {
          options.headers = {}; // Create the headers object if needed.
        }
        options.headers['authorization'] = `Bearer ${window.__root.graphQLToken}`;

        next();
      });
    }

    // Global error handling
    apolloFetch.useAfter(({ response }, next) => {
      if (!response.globalErrorsHandled) {
        response.globalErrorsHandled = true;
        this._handleGraphQLError(response);
      }
      next();
    });

    store.dispatch(login(window.__root.userId));
    store.dispatch(setUserName(window.__root.userFirstName, window.__root.userLastName));
    store.dispatch(setOwnerId(window.__root.calendarUserId));
    store.dispatch(setInkindId(window.__root.calendarInkindId));
    store.dispatch(setInkindRouteId(window.__root.inkindRouteId));
    store.dispatch(setInkindTitle(window.__root.inkindTitle));
    store.dispatch(setIsFollowingInkind(window.__root.isFollowingInkind));
    store.dispatch(setInkindPageThumbnailSmall(window.__root.inkindPageThumbnailSmall));
    if (window.__root.guessUserTimezone) {
      window.__root.userTz = moment.tz.guess();
    }
    store.dispatch(setTimezone(window.__root.userTz));
    store.dispatch(setCalendarTimezone(window.__root.calendarTimeZone));
    store.dispatch(setRecipientContactInformation(window.__root.recipientContactInformation));
    store.dispatch(setAntiForgeryToken(window.__root.antiForgery));
  }

  render () {
    const { children } = this.props;
    const { ready } = this.state;

    const classNames = cx(['app', legacyAppClassName]);

    return (
      <>
        <UIWrapperWithSingleton portal={document.body}>
          <GoogleMapsAPIWrapper>
            {ready && children}
          </GoogleMapsAPIWrapper>
        </UIWrapperWithSingleton>
      </>
    );
  }

  _handleGraphQLError (response) {
    if (response.status !== 200) {
      console.error('GraphQL returned non-200 response: ', response);
      response.parsed = response.parsed || {};
      response.parsed.errors = [
        {
          message:
            response.parsed.exceptionMessage ||
            response.parsed.message ||
            `Unable to parse response body - status: ${response.status}`,
          code: response.status,
        },
      ];
    } else {
      if (response.parsed.errors) {
        console.error('GraphQL returned 200 response with errors:', response);
      }
    }
    if (response.parsed.errors && response.parsed.errors.length) {
      const firstError = response.parsed.errors[0];
      console.error(firstError, 'GraphQL error');
      store.dispatch(setFatalCalendarError(firstError));
    }
  }
}
